module.exports = __webpack_public_path__ + "img/cq-title-icon.ceb8468f.png";